import { connect } from "react-redux";
// Component
import SetupAttr from "components/SetupAttr";
// Action
import {
  openConfirmDialog,
  closeConfirmDialog
} from "redux/modules/confirmDialog";

import { showSnackbar } from "redux/modules/snackbar";
import { openErrorDialog } from "redux/modules/errorDialog";
import {
  setErrors,
  setAttrs,
  setSetupAttrLocale,
  updateAttrItem,
  updateSetupAttrOrder,
  removeSetupAttrItem,
  openEditAttrModal
} from "redux/modules/setupAttr";
// Utils
import history from "utils/history";
import api from "api";

const validate = () => {
  const errors = [];
  return errors;
};
const mapStateToProps = state => ({
  setupAttr: state.setupAttr
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  historyPush: path => history.push(path, ownProps),
  fetchAttrDetail: () => {
    const { params } = ownProps.match;
    const { id } = params;
    api
      .get(`customer_attrs/${id}`)
      .then(res => dispatch(setAttrs(res)))
      .catch(error => dispatch(openErrorDialog(error)));
  },
  handleUpdate: setupAttr => {
    const errors = validate();
    dispatch(setErrors(errors));

    if (errors.length > 0) {
      return;
    }

    const params = {
      setupAttr
    };

    const dialogData = {
      title: "確認",
      contentText: "属性情報を更新します。よろしいですか？",
      btnLabel: "更新",
      handleClick: () => {
        const { id } = ownProps.match.params;
        api
          .patch(`customer_attrs/${id}`, params)
          .then(res => {
            dispatch(closeConfirmDialog());

            if (res.errors) {
              dispatch(openErrorDialog(res.errors));
            } else {
              dispatch(showSnackbar("属性情報を更新しました。"));
              if (ownProps.history.length === 1) {
                window.close();
              } else {
                ownProps.history.goBack();
              }
            }
          })
          .catch(error => dispatch(openErrorDialog(error)));
      }
    };
    dispatch(openConfirmDialog(dialogData));
  },
  changeLocale: (event, localeNo) => {
    dispatch(setSetupAttrLocale(localeNo));
  },
  changeAttrOrder: (attr, index, atIndex) => {
    dispatch(updateSetupAttrOrder(attr, index, atIndex));
  },
  openEditAttrModal: id => {
    dispatch(openEditAttrModal(id));
  },
  removeAttr: id => {
    dispatch(removeSetupAttrItem(id));
  },
  changeItem: (name, value) => {
    dispatch(updateAttrItem(name, value));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(SetupAttr);



// WEBPACK FOOTER //
// ./src/containers/SetupAttr/index.js